import { EventItem, EventItemKeyElements } from '../../data-types/sports/sportsInterfaces';

export type SportsbookEventsActionType = SetSportsbookEvents | UpdateSportsbookEvent | DeleteSportsbookEvent | ResetSportsbookEvent;

export const SET_SPORTSBOOK_EVENTS = 'SET_SPORTSBOOK_EVENTS';
export const UPDATE_SPORTSBOOK_EVENT = 'UPDATE_SPORTSBOOK_EVENT';
export const DELETE_SPORTSBOOK_EVENT = 'DELETE_SPORTSBOOK_EVENT';
export const RESET_SPORTSBOOK_EVENTS = 'RESET_SPORTSBOOK_EVENTS';

export interface SportsbookEventsState {
  [key: string]: EventItem;
}

interface UpdateSportsbookEvent {
  type: typeof UPDATE_SPORTSBOOK_EVENT;
  meta: EventItem;
}

interface DeleteSportsbookEvent {
  type: typeof DELETE_SPORTSBOOK_EVENT;
  meta: EventItemKeyElements;
}

interface ResetSportsbookEvent {
  type: typeof RESET_SPORTSBOOK_EVENTS;
}

interface SetSportsbookEvents {
  type: typeof SET_SPORTSBOOK_EVENTS;
  meta: SportsbookEventsState;
}
